import UrlPattern from 'url-pattern';

const getPath = (path) => path.replace(/\((.*)\)/, '$1?');

const createRoute = (path) => {
    const route = new UrlPattern(path);
    route.path = getPath(path);

    return route;
};

export const login = createRoute('/login');
export const recovery = createRoute('/recovery');
export const recoverySuccess = createRoute('/recovery/success');
export const reset = createRoute('/reset/:authToken');

export const main = createRoute('/');
export const profile = createRoute('/profile');

export const actionVacancies = createRoute('/action_vacancies');
export const applications = createRoute('/applications(/:status)');
export const approvalApplications = createRoute('/approval/application(/:status)');
export const actions = createRoute('/actions');
export const events = createRoute('/events(/:status)');
export const courses = createRoute('/courses(/:status)');

export const personTimetable = createRoute('/event/:project');

export const scenario = createRoute('/scenario(/:id)');

export const requestAdd = createRoute('/add/request(/:id)');
export const request = createRoute('/request(/:status)');
export const approvalPerson = createRoute('/approval/person(/:status)');
export const approvalProject = createRoute('/approval/project(/:status)');

export const requestMetro = createRoute('/metro/requests(/:status)');
export const requestMetroApproval = createRoute('/metro/approvals(/:status)');
export const requestMetroAdd = createRoute('/metro/request');
export const requestMetroEdit = createRoute('/metro/request/:id');

export const project = createRoute('/person(/:id)');
export const worksheet = createRoute('/project/:id/worksheet');
export const projectMass = createRoute('/project_mass(/:id)');
export const worksheetMassStage = createRoute('/project_mass/:id/worksheet(/:stage)');

export const calendarCurrent = createRoute('/calendar');
export const calendar = createRoute('/person/:id/calendar');

export const notification = createRoute('/notification');
export const trainerEvents = createRoute('/trainer/events');
export const trainerTimetable = createRoute('/trainer/timetable/:project');

export const news = createRoute('/news');

export const registration = createRoute('/registration');

export const fileLibrary = createRoute('/file_library');

export const NOTIFICATION_ROUTES = [
    { type: 'notdone', route: main.stringify() },
    { type: 'person', route: approvalPerson.stringify({ status: 'inwork' }) },
    { type: 'project', route: approvalProject.stringify({ status: 'inwork' }) }
];

export const approvalLink = createRoute('/approval');
export const testLink = createRoute('/test/link');
export const metroApprovalLink = createRoute('/metro/link');
